// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af379939","453":"37e38278","455":"45c49c66","818":"1e981e82"}[chunkId] + ".chunk.js";
};